module.exports = __webpack_public_path__ + "img/renyuan.ed5a96b3.png";